module.exports = __webpack_public_path__ + "img/mini-012.a41ee236.jpg";